module.exports = __webpack_public_path__ + "0f30ee7119accd1d44b85eaf83ebe449.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/designieumsae/img/top_logo.png
// module id = 1760
// module chunks = 1